import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center"
    },
    description: {
        textAlign: "center"
    },
    iconContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    title: {
        textAlign: "center"
    }
});

export default stylesheet;
